<template>
  <div class="uploaddata">
    <div class="content">
      <el-form label-position="top" :rules="rules" ref="ruleForm" label-width="80px" inlineMessage status-icon :model="formCase">
        <el-form-item label="经销店名称" prop="dealerName">
          <el-input readonly v-model="formCase.dealerName"></el-input>
        </el-form-item>
        <el-form-item label="服务委托书编号" prop="title">
          <el-input readonly v-model="formCase.caseNo"></el-input>
        </el-form-item>
        <el-form-item label="VIN" prop="title">
          <el-input readonly v-model="formCase.vin"></el-input>
        </el-form-item>
        <el-form-item label="附件(视频)" v-if="formCase.status!=='通过'&&formCase.status!=='已提交'">
        <Upload url="api/file/Upload" :flag="flags" type="video" :caseNo="formCase.caseNo" :attac="formCase.attachmentIds" :fileList="fileList.filter(item=> item.type&&item.type.indexOf('video')>=0)" @sub1="subs" @changeAttach="changeAttachs"></Upload>
        </el-form-item>
        <el-form-item label="附件(照片)" v-if="formCase.status!=='通过'&&formCase.status!=='已提交'">
        <Upload url="api/file/Upload" :flag="flags" type="image" :caseNo="formCase.caseNo" :attac="formCase.attachmentIds" :fileList="fileList.filter(item=> item.type&&item.type.indexOf('image')>=0)" @sub1="subs" @changeAttach="changeAttachs"></Upload>
        </el-form-item>

        <div  v-if="formCase.attaGroup">
        <div class="" v-for="it in Object.keys(formCase.attaGroup)">
          <el-form-item label="" prop="title">
            <span style="margin-right: 20px; width: 100px;float: left;">{{it}}</span>
            <el-button type="primary" size="mini" v-if="it !== users.name" @click="rejectUserFn(it)">退回</el-button>
            <!-- <el-button type="primary" size="mini" @click="confirmUserFn(it)">全部承认</el-button> -->
          </el-form-item>
          <el-row class="row-bg">
            <el-col :span="10" style="margin-right: 6%;position:relative" v-for="(item, index) in formCase.attaGroup[it]" :key="index">
              <img :src="item.url" preview="2" style="width: 100%" alt="" class="picture" v-if="item.type&&item.type.indexOf('image')>=0">
              <!-- <video :src="item.url" preload="auto" x5-playsinline style="width: 150px;height:150px;posiiton:relative;z-index:99999;"  x-webkit-airplay="true" x5-video-player-type="h5" x5-video-player-fullscreen="true" v-if="item.type&&item.type.indexOf('video')>=0"  webkit-playsinline="true" playsinline="true" controls></video> -->
              <el-row style="height:180px; width:100%;" v-else-if="item.type&&item.type.indexOf('video')>=0">
                <div style="position:absolute;height:160px;width:100%;" >
                  <video :src="item.url" style="width: 100%;object-fit:fill;height: 100%;" controls="controls" preload="auto" x5-video-player-fullscreen="true" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-playsinline></video>
                  <a style="position:relative;top:0;right:-100px;z-index:999;" :href="item.url" download>下载</a>
                </div>
              </el-row>
              <div style="width:100%;height:100%;" v-else><i class="el-icon-document" style="color:#000;font-size:80px;text-align:center;line-height:148px;width:100%;float:left"></i><a :href="'api/'+item.url" style="position:absolute;width:100%;height:100%;top:0;left:0" alt="" download></a></div>
              <div v-if="item.dtrStatus==='待审批'">
                <!-- <el-button type="primary" size="mini" @click="rejectFn(item.id)">打回</el-button> -->
                <el-button type="primary" size="mini" @click="delFn(item.id)">删除</el-button>
                <!-- <el-button type="primary" size="mini" @click="confirmFn(item.id)">承认</el-button> -->
              </div>
              <div v-if="item.dtrStatus==='被打回'">
                附件状态： 退回
              </div>
            </el-col>
          </el-row>
        </div>
        </div>

        <p style="color: red;font-size:12px">提示：案件提交后同批次编号数据将自动锁定，无法重复提交</p>
        <el-form-item style="text-align: center">
          <el-button type="info" @click.native="cancels">返回</el-button>
          <el-button type="primary" @click.native="onSubmitCase">提交</el-button>
          <!-- <el-button type="primary" @click.native="onSubmit">全部通过</el-button> -->
          <!-- <el-button type="danger" @click.native="onDelete">全部打回</el-button> -->
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type="text/javascript">
import Upload from './Upload'
import axios from '@/utils/api.request'
import {getImg} from '@/api/case'
import { Toast, MessageBox } from 'mint-ui'
import { rejectCase, getDetailData,removeOneCase, confirmCase, rejectCaseByUser, confirmCaseByUser, submitCase,rejectCaseByCase,confirmCaseByCase } from '@/api/quality'
import Global from '@/config/global.js'
export default{
  components: { Upload },
  data() {
    return {
      rules: {},
      formCase: {},
      fileList: [],
      attachmentIdss: [],
      sub: false,
      flags: false,
      users: {}
    }
  },
  created() {
    this.getData()
    this.users = JSON.parse(localStorage.getItem("user"))
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.flags = true
    } else {
       this.flags = false
    }
  },
  methods: {
    getData() {
      getDetailData({caseNo:this.$route.params.caseNo, vin:this.$route.params.vin}).then(res => {
        if(res.data.success){
          this.formCase = res.data.data
          if(this.formCase.attaGroup&&Object.keys(this.formCase.attaGroup)){
            let groupList = Object.keys(this.formCase.attaGroup)
            groupList.forEach((it) => {
              let arr = []
              this.formCase.attaGroup[it].forEach((v, i) => {
                let json = {
                  id: v.id,
                  name: v.rawName,
                  url: v.url,
                  type: v.mime,
                  dtrStatus: v.dtrStatus
                }
                arr.push(json)
                if(v.mime.indexOf('image')>=0){
                  getImg(v.url).then(resp=>{
                    var mimeType = v.mime.toLowerCase();
                    var imgBase64 = new Buffer(resp.data, 'binary').toString('base64');
                    arr[i].url = 'data:' + mimeType + ';base64,' + imgBase64;
                  })
                }else if(v.mime.indexOf('video')>=0){
                   arr[i].url = Global.server_api + v.url;
                }

              })
              this.formCase.attaGroup[it] = arr
              console.log(arr)
            })

          }
          // Toast({
          //   message: '获取案件成功',
          //   iconClass: 'icon el-icon-check'
          // })
        }else{
          // this.$message({
          //   type: 'error',
          //   message: res.data.msg
          // })
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
    },
    onSubmit() {
      confirmCaseByCase({caseNo: this.formCase.caseNo, vin: this.formCase.vin,}).then(res => {
        if(res.data.success){
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-check'
          })
          this.getData()
        }else{
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
    },
    onSubmitCase() {
      //MessageBox.confirm('确定执行此操作?')
      MessageBox.confirm('提交后不能撤回, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        submitCase({caseNo:this.formCase.caseNo, vin: this.formCase.vin}).then(res => {
          if(res.data.success){
            Toast({
              message: res.data.msg,
              iconClass: 'icon el-icon-check'
            })
          }else{
            Toast({
              message: res.data.msg,
              iconClass: 'icon el-icon-close'
            })
          }
        })
      }).catch(() => {
      });

    },
    onDelete() {
      rejectCaseByCase({caseNo: this.formCase.caseNo, vin: this.formCase.vin}).then(res => {
        if(res.data.success){
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-check'
          })
          this.getData()
        }else{
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
    },
    cancels() {
      this.$router.go(-1);
    },
    rejectFn(id) {
      console.log(this.formCase)
      rejectCase({caseNo: this.formCase.caseNo, vin: this.formCase.vin, attaId: id}).then(res => {
        if(res.data.success){
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-check'
          })
          this.getData()
        }else{
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
    },
    delFn(id) {
      removeOneCase({caseNo: this.formCase.caseNo, vin: this.formCase.vin, id: id}).then(res => {
        if(res.data.success){
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-check'
          })
          this.getData()
        }else{
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
    },
    rejectUserFn(id) {
      console.log(this.formCase)
      rejectCaseByUser({caseNo: this.formCase.caseNo, vin: this.formCase.vin, userId: id}).then(res => {
        if(res.data.success){
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-check'
          })
          this.getData()
        }else{
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
    },
    confirmFn(id) {
      confirmCase({caseNo: this.formCase.caseNo, vin: this.formCase.vin, attaId: id}).then(res => {
        if(res.data.success){
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-check'
          })
          this.getData()
        }else{
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
    },
    confirmUserFn(id) {
      confirmCaseByUser({caseNo: this.formCase.caseNo, vin: this.formCase.vin, userId: id}).then(res => {
        if(res.data.success){
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-check'
          })
          this.getData()
        }else{
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
    },
    subs(data) {
      this.sub = data
    },
    changeAttachs(data) {
        console.log(data)
      this.attachmentIdss = data;
      this.getData()
    },
    getSign() {
      let url = location.href.split('#')[0]
    },
  }
}
</script>

<style scoped>
.uploaddata{
  margin:auto;
  background: #fff;
  text-align: left;
  padding: 0.3rem;
}
.el-button--mini, .el-button--mini.is-round{
  padding: 4px 5px;
}
</style>
